/**
 * Dawn compatibility shim: slider-component
 * Provides the API expected by media-gallery:
 * - items[]
 * - isSlideVisible()
 * - slideTo()
 */
(() => {
  if (customElements.get("slider-component")) return;

  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.items = [];
    }

    connectedCallback() {
      this.slider =
        this.querySelector("[id^='Slider-']") ||
        this.querySelector("[data-slider]") ||
        this.querySelector("ul") ||
        this.querySelector("ol");

      this.items = this.slider ? Array.from(this.slider.children) : [];
    }

    /**
     * Dawn uses this to determine if a thumbnail is visible
     */
    isSlideVisible(index, slider = this.slider) {
      if (!slider || !this.items.length) return true;

      const slide = this.items[index];
      if (!slide) return true;

      const viewport = slider.getBoundingClientRect();
      const rect = slide.getBoundingClientRect();
      const tol = 1;

      return rect.left >= viewport.left - tol && rect.right <= viewport.right + tol;
    }

    /**
     * Scroll thumbnail into view
     */
    slideTo(index) {
      if (!this.items.length) return;

      const slide = this.items[index];
      if (!slide) return;

      slide.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }

  customElements.define("slider-component", SliderComponent);
})();
